import angular from 'angular';
import merge from 'lodash/merge';

export default angular.module('dashboard-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = merge(appFactory.deps.config.errorCodes, {
      dashboard: {
        REPORT_NOT_FOUND: () => ({ title: gettextCatalog.getString('Report not found.') }),
        REPORT_GENERATION_FAILED: () => ({ title: gettextCatalog.getString('Report generation failed.') }),
        REPORT_NOT_AVAILABLE: () => ({ title: gettextCatalog.getString('Report not yet available.') }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/config/errorcode.conf.js